exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hero-into[data-v-3ed0ff52]{font-size:22px;margin:0 25px}.hero-into[data-v-3ed0ff52],.sub-title[data-v-3ed0ff52]{text-align:center;color:#fff}.sub-title[data-v-3ed0ff52]{font-size:18px}.sub-sub-title[data-v-3ed0ff52]{color:#fff;text-align:center;font-size:16px}@media screen and (min-width:767px){.hero-into[data-v-3ed0ff52]{font-size:50px}.sub-title[data-v-3ed0ff52]{font-size:30px}.sub-sub-title[data-v-3ed0ff52]{font-size:20px}}", ""]);

// exports
